import TypographyComponent from './Typography';
export const Typography = TypographyComponent;
export type { TypographyVariant } from './Typography';
export default Typography;
